import { render } from "./PrestasiKodAkaun.vue?vue&type=template&id=789e0ba8"
import script from "./PrestasiKodAkaun.vue?vue&type=script&lang=js"
export * from "./PrestasiKodAkaun.vue?vue&type=script&lang=js"

import "./PrestasiKodAkaun.vue?vue&type=style&index=0&id=789e0ba8&lang=css"
import "./PrestasiKodAkaun.vue?vue&type=style&index=1&id=789e0ba8&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__